import { Injectable } from '@angular/core';
import { ReportesRequestService } from './request/reportes-request.service';

@Injectable({
  providedIn: 'root'
})
export class ServicioAnticipoService {

  constructor(private requestUrl: ReportesRequestService) { }

  async getAnticipos(codigoBD: string, uncoAdmision: number) {
    try {
      let response = await this.requestUrl.getRequest(
        'anticipos/lista',
        [codigoBD, {
          ln_unco_admsn: uncoAdmision
        }]
      );
      return response;
    } catch (e) {
      console.log(`ServicioAnticipoService.getAnticipos() ${e}`);
    }
    return null;
  }

  async getEntidadEmpresarial(codigoBD: string, sede: number) {
    try {
      const response = await this.requestUrl.getRequest(
        'entidad-empresarial/datos-entidad-sp',
        [codigoBD, { unco_sede: sede }]
      );
      return response;

    } catch (e) {
      alert(e);
      console.log(`ServicioAnticipoService.getEntidadEmpresarial() ${e}`);
    }
    return null;
  }

  async getInformacionAfiliado(codigoBD: string, filtro: FiltroInfoAfiliado) {
    try {
      const response = await this.requestUrl.getRequest(
        'anticipos/informacion-afiliado',
        [codigoBD, {
          ln_accion: 1,
          ln_unco_sde: filtro.uncoSede,
          ln_nmro_admsn: filtro.consecutivo,
          ln_unco_prmtro_insttcnl: null,
          ln_unco_lgn: filtro.uncoLogin,
          ln_error: 0
        }]
      );
      return response;

    } catch (e) {
      alert(e);
      console.log(`ServicioAnticipoService.getInformacionAfiliado() ${e}`);
    }
    return null;
  }
}

export interface Anticipo {
  fechaPago: string;
  numeroRecibo: string;
  formaPago: string;
  descripcion: string;
  estadoRegistro: string;
  usuario: string;
  concepto: string;
  valor: number;
  unco: number;
}

export class EntidadEmpresarial {
  identificacionTributaria: string = "";
  digitoVerificacion: string = "";
  descripcion: string = "";
  direccion: string = "";
  telefono: string = "";
  urlLogo: string = "";
  codigoPrestador: string = "";
  sede: string = "";
}

export interface AfiliadoAdmision {
  empresa: string;
  direccion: string;
  telefono: string;
  barrio: string;
  fechaAdmision: string;
  fechaNacimiento: string;
  identificacion: string;
  nombre: string;
  numeroAdmision: string;
  uncoAdmision: number;
  uncoAdmisionEmpresa: number;
  edad: string;
}

interface FiltroInfoAfiliado {
  consecutivo: string;
  uncoLogin: number;
  uncoSede: number;
}
